import domContentLoaded from 'dom-content-loaded';

export default () => {
	domContentLoaded(() => {
		const pagetitle = document.querySelector('.js-pagetitle');
		if (pagetitle) {
			const pagetitleContent = pagetitle.textContent;
			const pagetitleTxts = pagetitleContent.split('');
			let delay = 0;
			let pagetitleResult = '';
			pagetitleTxts.forEach((pagetitleTxt) => {
				pagetitleResult = `${pagetitleResult}<span style="transition-delay:${delay * 0.1}s">${pagetitleTxt}</span>`;
				delay += 1;
			});
			pagetitle.innerHTML = pagetitleResult;
		}
	});
}
